import React from 'react';
import { motion } from 'framer-motion';
import usePerformanceOptimization from '../../hooks/usePerformanceOptimization';

const CleanHeading = ({
  children,
  className = '',
  size = 'text-4xl',
  animate = true,
  variant = 'primary'
}) => {
  const { shouldReduceAnimations, getOptimizedProps } = usePerformanceOptimization();

  const textVariants = {
    initial: {
      opacity: 0,
      y: shouldReduceAnimations ? 8 : 20,
    },
    animate: {
      opacity: 1,
      y: 0,
      transition: {
        duration: shouldReduceAnimations ? 0.3 : 0.6,
        ease: "easeOut"
      }
    }
  };

  const shouldAnimate = animate && !shouldReduceAnimations;

  const variantStyles = {
    primary: 'text-foreground',
    accent: 'text-brand-primary',
    secondary: 'text-brand-secondary',
    white: 'text-white'
  };

  // Handle responsive text sizing properly
  const getResponsiveSize = (sizeString) => {
    // If it's already a responsive string, return as is
    if (sizeString.includes('sm:') || sizeString.includes('md:') || sizeString.includes('lg:')) {
      return sizeString;
    }
    // If it's a single size, return as is
    return sizeString;
  };

  const responsiveSize = getResponsiveSize(size);

  return (
    <motion.h1
      className={`font-heading font-bold ${responsiveSize} leading-tight ${variantStyles[variant]} ${className}`}
      {...getOptimizedProps({
        variants: shouldAnimate ? textVariants : {},
        initial: shouldAnimate ? "initial" : false,
        animate: shouldAnimate ? "animate" : false
      })}
    >
      {children}
    </motion.h1>
  );
};

export default CleanHeading;
